import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { Auth0Provider } from '@auth0/auth0-react';
import { AUTH_CONFIG } from './config/config';

const { DOMAIN, CLIENT_ID, AUDIENCE } = AUTH_CONFIG.AUTH0;
const redirectUri = window.location.origin + '/Home';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Auth0Provider solo es necesario en modo auth0
// Pero lo mantenemos siempre para cumplir con las reglas de hooks
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={DOMAIN}
      clientId={CLIENT_ID}
      authorizationParams={{ redirect_uri: redirectUri, audience: AUDIENCE }}
      cacheLocation="localstorage"
      useRefreshTokens={false}
      sessionCheckExpiryDays={0}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

reportWebVitals();
